import { MessageDescriptor } from 'react-intl';

import {
  ONBOARDING_PROVISIONING_STATE,
  ONBOARDING_PROVISIONING_STEP,
  Onboardingstatus,
} from '@/api/Seller/getSalesLeadOnboardingStatusQuery';

import messages from './messages';
import { STEP_STATE, StepState } from './OnboardingSetUp.constants';

export const PROVISIONING_STEPS = Object.values(ONBOARDING_PROVISIONING_STEP);

export function getStepMessage(
  step: ONBOARDING_PROVISIONING_STEP,
): MessageDescriptor {
  switch (step) {
    case ONBOARDING_PROVISIONING_STEP.TEMPLATE_DUPLICATION:
      return messages.stepTemplateDuplication;
    case ONBOARDING_PROVISIONING_STEP.DEMO_ORDERS:
      return messages.stepDemoOrders;
    case ONBOARDING_PROVISIONING_STEP.DEMO_FILES:
      return messages.stepDemoFiles;
    case ONBOARDING_PROVISIONING_STEP.SELLER_CONTEXT:
    default:
      return messages.stepSellerContext;
  }
}

export function getStepStateMessage(state: StepState): MessageDescriptor {
  switch (state) {
    case STEP_STATE.DONE:
      return messages.stepDone;
    case STEP_STATE.FAILED:
      return messages.stepFailed;
    case STEP_STATE.PENDING:
      return messages.stepPending;
    case STEP_STATE.RUNNING:
    default:
      return messages.stepRunning;
  }
}

export function getCurrentStepIndex(status?: Onboardingstatus): number {
  if (status?.provisioningState === ONBOARDING_PROVISIONING_STATE.READY) {
    return PROVISIONING_STEPS.length;
  }

  return status?.provisioningStep
    ? PROVISIONING_STEPS.indexOf(status.provisioningStep)
    : 0;
}

export function getProgressPercent(currentStepIndex: number): number {
  const stepCount = PROVISIONING_STEPS.length;
  const completedSteps =
    currentStepIndex >= stepCount ? stepCount : currentStepIndex + 0.5;

  return Math.round((completedSteps / stepCount) * 100);
}

export function getStepState({
  index,
  currentStepIndex,
  isFailed,
}: {
  index: number;
  currentStepIndex: number;
  isFailed: boolean;
}): StepState {
  if (index < currentStepIndex) {
    return STEP_STATE.DONE;
  }
  if (index > currentStepIndex) {
    return STEP_STATE.PENDING;
  }

  return isFailed ? STEP_STATE.FAILED : STEP_STATE.RUNNING;
}
